import { ChangeDetectorRef, Component, Input, Output, OnChanges, EventEmitter, SimpleChanges } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { RestClient } from "../../Api/DcoApi/Client/RestClient";
import { Observable } from "rxjs/internal/Observable";
import { Auftrag } from "../../Api/DcoApi/Auftraege";
import { CommonModule } from '@angular/common';
import { Patient } from "../../Api/DcoApi/Patient";
import { FileEntry } from "../../Api/DcoApi/AktenEintraege/FileEntry";


@Component({
  selector: 'FileList',
  templateUrl: './FileList.html',
  styleUrl: './FileList.css',
  imports: [FormsModule, CommonModule],
  standalone: true,
})

export class FileList implements OnChanges {
  constructor(private cdr: ChangeDetectorRef) { }
  ngOnChanges(changes: SimpleChanges): void {

  }
  //Schreiben Kasse
  FileTypeEnum = [
    { Key: "Antrag", Value: "Antrag", index: 5 },
    { Key: "Wechselerklaerung", Value: "Wechselerklaerung", index: 9 },
    { Key: "KuendigungsbestaetigungLE", Value: "Kündigungsbestätigung LE", index: 13 },
    { Key: "Vollmacht", Value: "Vollmacht", index: 12 },
    { Key: "Genehmigung", Value: "Schreiben Kasse", index: 2 },
    { Key: "GenehmigungKasse", Value: "Genehmigung Kasse", index: 14 },
    { Value: "---", Disabel: true },
    { Key: "Notfallplan", Value: "Notfallplan", index: 11 },
    { Key: "ASBBestaetigung", Value: "Leitstelle Bestätigung", index: 10 },
    { Key: "Inbetriebnahme", Value: "Inbetriebnahme", index: 1 },
    { Value: "---", Disabel: true },
    { Key: "Mehrkostenerklaerung", Value: "Mehrkostenerklaerung", index: 6 },
    { Key: "Eigentumsvorbehalt", Value: "Eigentumsvorbehalt", index: 15 },
    { Key: "SEPA", Value: "SEPA", index: 7 },
    { Key: "Rechnung", Value: "Rechnung", index: 8 },
    { Value: "---", Disabel: true },
    { Key: "Sendenachweis", Value: "Sendenachweis", index: 3 },
    { Key: "DHLSendenachweis", Value: "DHLSendenachweis", index: 4 },
    { Key: "Undefined", Value: "Undefined", index: 0 }
  ];

  Client: RestClient = new RestClient();
  @Input() Auftrag: Auftrag | null | undefined = null;
  @Output() AuftragChange = new EventEmitter<Auftrag | null>();
  @Input() Patient: Patient | null | undefined = null;

  SelectetFile: FileEntry | null = null;
  selectedFile: File | null = null;
  get Files(): FileEntry[] {
    return this.Auftrag?.dateien ?? [];
  }

  async UploadFile() {
    const input = document.createElement('input');
    input.type = 'file';

    // Event-Handler, wenn die Datei ausgewählt wurde
    input.onchange = (event: any) => {
      this.selectedFile = event.target.files[0];
      if (this.selectedFile) {
        this.SelectetFile = {} as FileEntry;
        this.cdr.detectChanges();
      }
    };

    // Öffnet den Datei-Dialog des Betriebssystems
    input.click();
  }

  async DeleteFile(key: number) {
    if (this.Auftrag != null) {
      await this.Client.Delete(`/Backend/Api/V2/Akte/${this.Patient?.versicherungsnummer}/Auftrag/${this.Auftrag?.key}/Dateien/${key}`);
      this.Auftrag.dateien = this.Auftrag.dateien.filter(file => file.key !== key);
      this.cdr.detectChanges();
    }
  }

  ChangeType(key: number) {
    if (this.Auftrag != null)
      this.SelectetFile = this.Auftrag.dateien.find(file => file.key === key) ?? null;
  }

  async SaveTypeOrUpload() {
    if (this.SelectetFile != null && this.Auftrag != null) {
      if (this.selectedFile != null) {
        this.Auftrag.dateien.push(await this.Client.PostFile<FileEntry>(`/Backend/Api/V2/Akte/${this.Patient?.versicherungsnummer}/Auftrag/${this.Auftrag?.key}/Dateien/${this.FileTypeEnum.find((element) => element.index == this.SelectetFile?.typ)?.Key}`, this.selectedFile));
      }
      else {
        await this.Client.Post<FileEntry, FileEntry>(`/Backend/Api/V2/Akte/${this.Patient?.versicherungsnummer}/Auftrag/${this.Auftrag?.key}/Dateien/${this.SelectetFile.key}/${this.FileTypeEnum.find((element) => element.index == this.SelectetFile?.typ)?.Key}`, this.SelectetFile);
      }
    }

    this.selectedFile = null;
    this.SelectetFile = null;
    this.cdr.detectChanges();
  }
  onSelectionChange(value: any) {
    if (this.SelectetFile != null)
      this.SelectetFile.typ = value as number ?? 0
  }
  Close() {
    this.SelectetFile = null;
  }
}
